import fromEntries from 'fromentries'
import { dateFromQueryParam } from './date_helpers'

// https://api.rubyonrails.org/classes/ActiveModel/Type/Boolean.html
const falseValues = [false, 0, '0', 'f', 'F', 'false', 'FALSE', 'off', 'OFF']
export function castQueryStringBoolean (value) {
  if (!value) return false
  return falseValues.indexOf(value) === -1
}

export function copySpecificSearchParamsFromUrl (names, url = window.location) {
  const newSearchParams = new URLSearchParams()
  const curSearchParams = new URL(url).searchParams

  names.forEach(param => {
    if (curSearchParams.has(param)) newSearchParams.set(param, curSearchParams.get(param))
  })

  return newSearchParams
}

export function getListingRouteFromReserveRoute (url = window.location) {
  url = new URL(url)
  const pathnameParts = url.pathname.split('/')
  if (!pathnameParts[pathnameParts.length - 1]) pathnameParts.pop() // remove empty entry from trailing slash
  pathnameParts.pop() // remove '/reserve'
  return `${pathnameParts.join('/')}/${url.search}`
}

export function getSearchPropsFromQueryString (url = window.location) {
  url = new URL(url)
  const entries = fromEntries(url.searchParams.entries())

  return {
    guests: entries.guests,
    checkIn: dateFromQueryParam(entries.check_in),
    checkOut: dateFromQueryParam(entries.check_out),
    discountCode: entries.discount_code,
    rateMin: entries.rate_min,
    rateMax: entries.rate_max,
    property: entries.property,
    collection: entries.collection,
    pets: castQueryStringBoolean(entries.pets),
    smoking: castQueryStringBoolean(entries.smoking),
    wheelchairAccessible: castQueryStringBoolean(entries.wheelchair_accessible),
    featured: castQueryStringBoolean(entries.featured)
  }
}
